export default {
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
  ASSIGNED_TO_PRACTICE: 'ASSIGNED_TO_PRACTICE',
} as const
